import { isNewIOSApp } from '@airtel-lego/native-app-bridge';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import videoPauseIcon from '../../assets/images/svg/video-pause.svg';
import videoPlayIcon from '../../assets/images/svg/video-play.svg';
import VideoTimer from './VideoTimer';

interface VideoReplayProps {
   src: string;
   timer : string
}

const VideoReplay: React.FC<VideoReplayProps> = ({ src , timer }) => {
   const videoRef = useRef<HTMLVideoElement>(null);
   const [isPlaying, setIsPlaying] = useState(false);
   const [showFadeAnimation, setShowFadeAnimation] = useState(false);
   const [currentTime, setCurrentTime] = useState(0);

   const handlePlayPause = () => {
      if (isPlaying) {
         videoRef?.current?.pause();
      } else {
         videoRef?.current?.play();
      }
   };

   useEffect(() => {
      setShowFadeAnimation(isPlaying);
   }, [isPlaying]);

   useEffect(() => {
      const videoElement = videoRef.current;
      if (!videoElement) return;

      videoElement.onplaying = () => setIsPlaying(true);
      videoElement.onpause = () => setIsPlaying(false);
      videoElement.ontimeupdate = () => {
         setCurrentTime(Math.ceil(videoElement.currentTime));
      };

      return () => {
         videoElement.onplaying = null;
         videoElement.onpause = null;
         videoElement.ontimeupdate = null;
      };
   }, []);

   const videoCurrentTime = useMemo(() => {
      return `00:${currentTime.toString().padStart(2, '0')}`;
   }, [currentTime]);

   const detectDevice = () => {
      const userAgent = navigator.userAgent.toLowerCase();

      if (/iphone|ipod|ipad/.test(userAgent)) {
         return true; // iPhone or iPod
      }
   }

   return (
      <div
         className="recorded-video-container"
         onClick={() => {
            setShowFadeAnimation((prev) => !prev);
         }}
      >
          <video ref={videoRef} src={src} />  
         <div
            className={`video-controls ${showFadeAnimation ? 'fadeOut' : 'fadeIn'}`}
            onClick={handlePlayPause}
         >
            <img
               src={isPlaying ? videoPauseIcon : videoPlayIcon}
               alt={isPlaying ? 'pause' : 'play'}
            />
         </div>
         <VideoTimer duration={isPlaying ? videoCurrentTime : timer} />   
      </div>
   );
};

export default VideoReplay;
